import { useEffect, useState } from 'react'

function useNetworkConnection(thresholdMbps = 1.5) {
  const [isOnline, setIsOnline] = useState(navigator?.onLine)
  const [isUnstable, setIsUnstable] = useState(false)
  const [networkType, setNetworkType] = useState('')

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  useEffect(() => {
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection
    if (!connection) return

    const updateUnstableStatus = () => {
      const { downlink, effectiveType } = connection

      setNetworkType(effectiveType)
      if (
        downlink < thresholdMbps ||
        ['slow-2g', '2g', '3g'].includes(effectiveType)
      ) {
        setIsUnstable(true)
      } else {
        setIsUnstable(false)
      }
    }

    updateUnstableStatus()
    connection.addEventListener('change', updateUnstableStatus)

    // eslint-disable-next-line consistent-return
    return () => {
      connection.removeEventListener('change', updateUnstableStatus)
    }
  }, [thresholdMbps])

  return { isOnline, isStable: !isUnstable, effectiveType: networkType }
}

export default useNetworkConnection
